import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import Dropdown from '../ui/Dropdown'

function Sidebar({ isOpen, onClose }) {
  const { displayName, initials, isAdmin, signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/')
  }

  return (
    <>
      {/* Mobile overlay */}
      <div
        className={`sidebar-overlay ${isOpen ? 'visible' : ''}`}
        onClick={onClose}
      />

      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <NavLink to="/" className="logo">
            <div className="logo-icon">SSV</div>
            <span>Second Shift Ventures</span>
          </NavLink>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">
            <div className="nav-section-title">Overview</div>
            <NavLink
              to="/dashboard"
              end
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">📊</span>
              Dashboard
            </NavLink>
            <NavLink
              to="/dashboard/expenses"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">💸</span>
              Expenses
            </NavLink>
            <NavLink
              to="/dashboard/financials"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">🧾</span>
              Financials
            </NavLink>
            <NavLink
              to="/dashboard/team"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">👥</span>
              Team
            </NavLink>
            <NavLink
              to="/dashboard/meetings"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">🗓️</span>
              Meetings
            </NavLink>
            <NavLink
              to="/dashboard/docs"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">📚</span>
              Docs
            </NavLink>
          </div>

          <div className="nav-section">
            <div className="nav-section-title">Ops</div>
            <NavLink
              to="/dashboard/mission-control"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">🦗</span>
              Mission Control
            </NavLink>
          </div>

          <div className="nav-section">
            <div className="nav-section-title">Manage</div>
            <NavLink
              to="/dashboard/subscriptions"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">🔄</span>
              Subscriptions
            </NavLink>
            <NavLink
              to="/dashboard/todos"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">✅</span>
              Todos
            </NavLink>
            <NavLink
              to="/dashboard/invoices"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">💵</span>
              Invoices
            </NavLink>
            <NavLink
              to="/dashboard/reports"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">📈</span>
              Reports
            </NavLink>
          </div>

          <div className="nav-section">
            <div className="nav-section-title">Settings</div>
            <NavLink
              to="/dashboard/settings"
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-link-icon">⚙️</span>
              Settings
            </NavLink>
            {isAdmin && (
              <NavLink
                to="/dashboard/users"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                onClick={onClose}
              >
                <span className="nav-link-icon">👥</span>
                Users
              </NavLink>
            )}
          </div>
        </nav>

        <div className="sidebar-footer">
          <Dropdown
            align="left"
            direction="up"
            trigger={
              <div className="user-menu">
                <div className="user-avatar">{initials}</div>
                <div className="user-info">
                  <div className="user-name">{displayName}</div>
                  <div className="user-role">{isAdmin ? 'Admin' : 'Member'}</div>
                </div>
                <span>▼</span>
              </div>
            }
          >
            <Dropdown.Item onClick={() => { navigate('/dashboard/profile'); onClose(); }}>
              👤 Profile
            </Dropdown.Item>
            <Dropdown.Item onClick={() => navigate('/')}>
              ← Back to Home
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleSignOut} danger>
              Sign Out
            </Dropdown.Item>
          </Dropdown>
        </div>
      </aside>
    </>
  )
}

export default Sidebar
